var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pravo-sirsi"},[(_vm.lobbyMe.isOwner)?_c('div',{staticClass:"button finalScreen__center__button__leave",staticStyle:{"margin":"1rem 1rem 0"},on:{"click":_vm.startGame}},[_vm._v(" Start game ")]):_vm._e(),_c('Control'),_c('Search'),_c('Teams')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }